/** @type {string} */
const toastString = "toast";
export default toastString;
